import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from "@emotion/react";
import { Fragment } from "react";
import { Grid, SkeletonBlock, Spacer, TagLabel, Text, Typography, } from "@zapier/design-system";
import { useSize } from "@zapier/upsells/esm/hooks";
const styles = {
    contentWrapper: (size) => css({
        padding: size === "small" ? 0 : "30px 0 30px 30px",
    }),
    heading: {
        ...Typography.sectionHeader3,
        marginBottom: 10,
    },
    imageContainer: (imageBackgroundColor, size) => ({
        alignItems: "center",
        background: imageBackgroundColor,
        display: size === "small" ? "none" : "flex",
        justifyContent: "center",
        padding: 40,
    }),
    subtitle: {
        ...Typography.smallPrint1,
    },
};
const getButtonsGridCols = (size) => {
    return size === "small"
        ? "repeat(fit-content, 100%)"
        : `repeat(auto-fill, minmax(200px, auto))`;
};
export const NudgeLayout = ({ bodyText, buttons, headingText, id, image, imageBackgroundColor = "none", subtitleText, }) => {
    const size = useSize();
    return (_jsx("div", { "data-testid": id, children: _jsxs(Grid, { columns: size === "small" ? "auto" : "minmax(300px, auto) 300px", gap: 40, children: [_jsxs("div", { css: styles.contentWrapper(size), children: [subtitleText && (_jsxs(Fragment, { children: [_jsx(TagLabel, { size: "small", children: subtitleText }), _jsx(Spacer, { height: 20 })] })), headingText ? (_jsx(Text, { color: "neutral800", tag: "h1", type: "pageHeader7", children: headingText })) : (_jsx(Fragment, { children: _jsx(SkeletonBlock, { height: 50, width: "100%" }) })), _jsx(Spacer, { height: 15 }), bodyText ? (_jsx(Text, { color: "neutral700", tag: "p", type: "paragraph3", children: bodyText })) : (_jsx(SkeletonBlock, { height: 65, width: "100%" })), _jsx(Spacer, { height: 20 }), buttons ? (_jsx(Grid, { columns: getButtonsGridCols(size), gap: 10, children: buttons })) : (_jsx(SkeletonBlock, { height: 50, width: "100%" }))] }), _jsx("div", { css: styles.imageContainer(imageBackgroundColor, size), children: size !== "small" && image })] }) }));
};

// @zapier/upsells@8.0.1 (466b4077f)
